import { Box, Divider, Typography, Tabs, Tab } from "@mui/material";
import { useCallback, useReducer, useState } from "react";
import EnhancedTable from "../../../enhancedTable/EnhancedTable";
import { isLocalDev } from "../../../../utils/environment";
import { ValidDataService } from "../../../../service/validDataService";
import useAbortController from "../../../../hooks/useAbortController";
import useDialogModal from "../../../../hooks/useDialogModal";
import ConfirmationDialog from "../../../ui/confirmationDialog";
import { toast } from "react-toastify";
import validLookup from "../../../../utils/validLookup";
import ValidLensInputForm from "./validLensInputForm";
import ValidLensEditForm from "./validLensEditForm";
import EditIcon from "@mui/icons-material/Edit";
import { useValidInventoryColumns } from "../useValidInventoryColumns";
import { ContentCopy } from "@mui/icons-material";
import { ValidLensBrand, ValidLensTreatment, ValidLensMaterial, ValidLensIndex, ValidLensModel, LensPricingMatrix } from '../lens';

export default function Lenses(props) {
    const [ValidLensInputDialog, showValidLensInputForm] = useDialogModal(ValidLensInputForm);
    const [ValidLensEditDialog, showValidLensEditForm] = useDialogModal(ValidLensEditForm);
    const columns = useValidInventoryColumns('lens');

    const [
        ConfirmationDialogComp,
        showConfirmationDialog,
        closeConfirmationDialog,
    ] = useDialogModal(ConfirmationDialog);

    const [signal, abortRequest] = useAbortController();
    const [state, updateState] = useReducer((state, params) => {
        return { ...state, ...params };
    }, {
        data: [],
        totalRowCount: 0,
        pageCount: 0,
        filter: '',
        loading: false,
    });

    const onAddRecordClicked = () => {
      showValidLensInputForm();
    }

    const handleRowEdit = (rowData) => {
        showValidLensEditForm(null, { recordToEdit: rowData });
    }

    const handleRowCopy = (rowData) => {
        const copiedData = {
            ...rowData,
            id: null,  // Remove ID so a new one will be generated
            modelNumber: `${rowData.modelNumber}-COPY`, // Append COPY to model number
            sku: `${rowData.sku}-COPY`, // Append COPY to SKU
            // Reset specific fields that should be unique or reset for new records
            quantityOnHand: 0,
            quantityOnOrder: 0,
            totalSold: 0,
            returned: 0,
            lastOrdered: null,
            lastReceived: null,
            lastSold: null,
            createdAt: null,
            updatedAt: null
        };

        showValidLensEditForm(null, { recordToEdit: copiedData, isCopy: true });
    }

    /**
    * fetch data
    */
    const fetchData = useCallback(({ pageSize, pageIndex, filters, sortBy }) => {
        const from = pageSize * pageIndex;
        updateState({ loading: true });
        ValidDataService.getInventoryDataWithLimit(from, pageSize, filters, sortBy, 'lens', signal).then(result => {
            const { code, data } = result;
            if (code === 0) {
                updateState({
                    data: data.data,
                    totalRowCount: data.count,
                    pageCount: Math.ceil(data.count / pageSize),
                });
            }
            updateState({ loading: false });
        }).catch(error => {
            if (isLocalDev) {
                console.error(error)
            }
            updateState({ loading: false });
        });
    }, []);

    const deleteRecordHandler = (rowids) => {
        showConfirmationDialog(async (action) => {
            if (action === validLookup.confirmationDialogAction.ok) {
                const deleteRecordResult = await ValidDataService.deleteInventoryRecord(rowids.map(x => parseInt(x, 10)));
                const { code, message, data } = deleteRecordResult;

                if (code === 0) {
                    toast.success(message);
                    const updateList = state.data.filter(d => !rowids.map(x => parseInt(x, 10)).includes(d.id));
                    updateState({ data: updateList });
                } else {
                    toast.success("Failed to delete record(s)");
                }
            }
            closeConfirmationDialog();
        }, {
            title: 'Delete record',
            message: `Please confirm if you would like to delete ${rowids.length} record(s)?`,
        });
    }

    const recordAddHandler = (newRecord) => {
        const newData = state.data.concat(newRecord);
        updateState({ data: newData });
    }

    const recordEditHandler = (record) => {
        // find the lens by row id
        const existingRecord = state.data;
        const idx = existingRecord.findIndex(e => e.id === record.id);
        const updatesList = existingRecord.map((row, index) => {
            if (row.id === record.id) {
                return {
                    ...existingRecord[idx], ...record,
                }
            }
            return row
        });

        // update list
        updateState({
            data: updatesList
        });
    }

    const [tabValue, setTabValue] = useState(0);

    function TabPanel({ children, value, index }) {
        return (
            <div role="tabpanel" hidden={value !== index}>
                {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
            </div>
        );
    }

    return (
        <Box>
            <Typography variant="h4">Lenses</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                Inventory and admin pages for lenses
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <Tabs value={tabValue} onChange={(e, nv) => setTabValue(nv)} sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                {/* <Tab label="Inventory" /> */}
                {/* <Tab label="Brands" /> */}
                <Tab label="Treatments" />
                <Tab label="Materials" />
                <Tab label="Indexes" />
                <Tab label="Models" />
                <Tab label="Pricing" />
            </Tabs>

            {/* <TabPanel value={tabValue} index={0}>
                <EnhancedTable
                    columns={columns}
                    addRecordHandler={onAddRecordClicked}
                    deleteRecordHandler={deleteRecordHandler}
                    data={state.data}
                    totalRowCount={state.totalRowCount}
                    pageCount={state.pageCount}
                    fetchData={fetchData}
                    loading={state.loading}
                    selectionMode="multi"
                    actions={[
                        {
                            icon: <EditIcon />,
                            onClick: handleRowEdit
                        },
                        {
                            icon: <ContentCopy />,
                            onClick: handleRowCopy
                        },
                    ]}
                />
                <ValidLensInputDialog onRecordAdded={recordAddHandler} />
                <ValidLensEditDialog onRecordUpdated={recordEditHandler} onRecordCopied={recordAddHandler}  />

                <ConfirmationDialogComp
                    label={{
                        positive: "Confirm",
                        negative: "Cancel",
                    }} />
            </TabPanel> */}

            {/* <TabPanel value={tabValue} index={0}>
                <ValidLensBrand />
            </TabPanel> */}
            <TabPanel value={tabValue} index={0}>
                <ValidLensTreatment />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
                <ValidLensMaterial />
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
                <ValidLensIndex />
            </TabPanel>
            <TabPanel value={tabValue} index={3}>
                <ValidLensModel />
            </TabPanel>
            <TabPanel value={tabValue} index={4}>
                <LensPricingMatrix />
            </TabPanel>
        </Box>
    )
}